import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["parentContentType", "wrapper", "children", "variant", "styling", "spacing", "textContent"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { useThemeUI } from 'theme-ui';
import { useComponent } from '@uswitch/ev-utils/lib/context/selectors'; // TODO: load this list from config

import { jsx as _jsx } from "theme-ui/jsx-runtime";
var parentIds = ['modularPage', 'richPage'];

var ContainerDivStyle = function ContainerDivStyle(_ref) {
  var children = _ref.children,
      styling = _ref.styling,
      variant = _ref.variant;

  var _useComponent = useComponent({
    tag: 'container'
  }),
      _useComponent2 = _slicedToArray(_useComponent, 2),
      C = _useComponent2[1];

  return _jsx(C, {
    className: '',
    children: _jsx("div", {
      sx: _objectSpread({
        variant: variant
      }, styling),
      children: children
    })
  });
};

var DivStyle = function DivStyle(_ref2) {
  var children = _ref2.children,
      styling = _ref2.styling,
      variant = _ref2.variant;
  return _jsx("div", {
    sx: _objectSpread({
      variant: variant
    }, styling),
    children: children
  });
};

var TextContentDiv = function TextContentDiv(_ref3) {
  var _theme$layout, _theme$layout$contain, _theme$layout$contain2;

  var children = _ref3.children;

  var _useComponent3 = useComponent({
    tag: 'container'
  }),
      _useComponent4 = _slicedToArray(_useComponent3, 2),
      C = _useComponent4[1];

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  return _jsx(C, {
    children: theme !== null && theme !== void 0 && (_theme$layout = theme.layout) !== null && _theme$layout !== void 0 && (_theme$layout$contain = _theme$layout.container) !== null && _theme$layout$contain !== void 0 && (_theme$layout$contain2 = _theme$layout$contain.content) !== null && _theme$layout$contain2 !== void 0 && _theme$layout$contain2.contentStyle ? _jsx("div", {
      sx: {
        variant: 'layout.container.content.contentStyle'
      },
      children: children
    }) : children
  });
};

var Container = function Container(_ref4) {
  var children = _ref4.children;

  var _useComponent5 = useComponent({
    tag: 'container'
  }),
      _useComponent6 = _slicedToArray(_useComponent5, 2),
      C = _useComponent6[1];

  return _jsx(C, {
    className: '',
    sx: {},
    children: children
  });
};

var SmartContainer = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var parentContentType = _ref5.parentContentType,
      wrapper = _ref5.wrapper,
      children = _ref5.children,
      variant = _ref5.variant,
      _ref5$styling = _ref5.styling,
      styling = _ref5$styling === void 0 ? {} : _ref5$styling,
      _ref5$spacing = _ref5.spacing,
      spacing = _ref5$spacing === void 0 ? {} : _ref5$spacing,
      _ref5$textContent = _ref5.textContent,
      textContent = _ref5$textContent === void 0 ? false : _ref5$textContent,
      props = _objectWithoutProperties(_ref5, _excluded);

  var _useComponent7 = useComponent({
    tag: 'palette'
  }),
      _useComponent8 = _slicedToArray(_useComponent7, 2),
      Palette = _useComponent8[1];

  var parentIsRootEntity = parentIds.includes(parentContentType); // do not use container if useContainer is false

  var useContainer = ((wrapper === null || wrapper === void 0 ? void 0 : wrapper.useContainer) !== false || (props === null || props === void 0 ? void 0 : props.useContainer)) && parentIsRootEntity;
  var useStyles = variant || Object.keys(styling).length > 0;
  return _jsx(Palette, _objectSpread(_objectSpread({
    as: "div",
    sx: parentIsRootEntity ? _objectSpread({}, spacing) : {},
    px: {
      backgroundColor: parentIsRootEntity ? 'backgroundColor' : '',
      color: 'textColor'
    }
  }, props), {}, {
    ref: ref,
    children: textContent && parentIsRootEntity ? _jsx(TextContentDiv, {
      children: children
    }) : useContainer && useStyles ? _jsx(ContainerDivStyle, {
      variant: variant,
      styling: styling,
      children: children
    }) : useStyles ? _jsx(DivStyle, {
      variant: variant,
      styling: styling,
      children: children
    }) : useContainer ? _jsx(Container, {
      children: children
    }) : children
  }));
});
export default SmartContainer;